import React from 'react';

import { Button, Box, Typography, Modal } from '@mui/material';

import UnsubscribeIcon from '../../../../common/assets/icons/unsubscribe_icon.svg';
import './SubscriptionPurchasedModal.scss';

const modalStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  borderRadius: 6,
  p: 4,
  textAlign: 'center',
  minWidth: 280,
  maxWidth: 460,
  paddingLeft: 10,
  paddingRight: 10,
};

type Props = {
  open: boolean;
  onClose: () => void;
  onAccept: () => void;
};

const UnsubscribeConfirmationModal: React.FC<Props> = ({
  open,
  onClose,
  onAccept,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <div>
          <img src={UnsubscribeIcon} alt='Unsubscribe' />
          <Typography sx={{ mt: 1, mb: 1 }} fontWeight={600} fontSize={18}>
            You are about to unsubscribe
          </Typography>
          <Typography color='gray'>
            Are you sure you want to stop your subscription?
          </Typography>
          <Button
            onClick={onAccept}
            variant='contained'
            color='error'
            disableElevation
            sx={{
              width: '100%',
              height: 48,
              marginTop: '20px',
              borderRadius: '15px',
            }}
          >
            <Typography color='white'>Yes, unsubscribe</Typography>
          </Button>
          <Button
            onClick={onClose}
            variant='contained'
            color='secondary'
            disableElevation
            sx={{
              width: '100%',
              height: 48,
              marginTop: '10px',
              borderRadius: '15px',
            }}
          >
            <Typography color='white'>No, thank you</Typography>
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default UnsubscribeConfirmationModal;
